import { gql } from '@common/hooks';
import { CommentInfoFragment, CommentInfoFragmentType } from '@common/graphql';

export const CreateStaffingRequestApplicationCommentMutation = gql`
  mutation CreateSupplierStaffingRequestApplicationNote(
    $applicationId: String!
    $input: CreateStaffingRequestApplicationCommentInput!
  ) {
    createStaffingRequestApplicationComment(
      staffingRequestApplicationId: $applicationId
      input: $input
    ) {
      comment {
        ...CommentInfoFragment
      }
    }
  }
  ${CommentInfoFragment}
`;

export type CreateStaffingRequestApplicationCommentResponse = {
  createStaffingRequestApplicationComment: {
    comment: CommentInfoFragmentType;
  };
};

export type CreateStaffingRequestApplicationCommentVariables = {
  applicationId: string;
  input: {
    contentAsText: string;
  };
};
